import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { observer } from 'mobx-react';
import { linearModel } from 'mobx-store';

import { getFilteredParametersValuesNotEmptyLength } from 'store/dataset';

import LinearModelComponent from './Component';

const LinearModelContainer = observer(
  class LinearModelContainer extends React.Component {
    static propTypes = {
      datasetLength: PropTypes.number
    }

    static defaultProps = {
      datasetLength: null
    }

    get isCategoricalParameterValid () {
      const categoricaLevels = linearModel.categoricalParameterLevels;
      return categoricaLevels ? categoricaLevels.length >= 2 : true;
    }

    get showRightAndBottomPanes () {
      return linearModel.parametersChoosen && this.isCategoricalParameterValid && this.props.datasetLength > 0;
    }

    render () {
      return (
        <LinearModelComponent
          showRightAndBottomPanes={
            this.showRightAndBottomPanes
          }
        />
      );
    }
  }
);

const mapStateToProps = state => {
  const primaryParameter = linearModel.primaryParameter && linearModel.primaryParameter.name;
  const secondaryParameter = linearModel.secondaryParameter && linearModel.secondaryParameter.name;

  return ({
    datasetLength: getFilteredParametersValuesNotEmptyLength(state, primaryParameter, secondaryParameter)
  });
};

export default connect(mapStateToProps)(LinearModelContainer);
